import React, { useEffect, useState } from 'react';
import { useNotify } from 'react-admin';
import { CustomFilter } from '@/components/Global';
import { ParseExportInventoryList } from '@/actions/ParseData';
import { noScroll, removeNoScroll } from '@/actions/Helper';
import {
  getExportInventory,
  delExportInventory,
  importExportInventory,
  upBooking,
  getTableList,
  deleteAllBookingsApi,
  SaveApiResMessage,
} from '@/actions';

import Add from './Add';
import List from './List';
import Edit from './Edit';
import styles from './styles';
import Pagination from '@/components/pagination';
import Options from '@/components/Global/Options';
import LoadingV2 from '@/components/Loading';
import PageContainer from '@/components/PageContainerAB/pageContainer';
import AddButton from '@/components/AddButton';
import IconButton from '@/ctComponents/IconButton';
import Modal from '@/ctComponents/Modal';
import SearchContainer from '../Appointments/SearchContainer';
import CustomBadge from '@/components/CustomBadge';

export default (props) => {
  const cls = styles();
  const notify = useNotify();
  const [state, setState] = React.useState({
    edit: null,
    file: null,
  });
  const [pagination, setPagination] = React.useState({
    currentPage: 1,
    pages: [],
  });
  const [loading, setLoading] = React.useState(true);
  const [DATA, setData] = React.useState([]);
  const [filteredData, setFilteredData] = React.useState([]);
  const [searchQuery, setSearchQuery] = React.useState('');
  const [filter, setFilter] = React.useState({
    open: false,
    DATA: [],
    appliedFilters: {},
  });
  const [options, setOptions] = React.useState({
    open: false,
    DATA: [],
  });
  const [openAdd, setOpenAdd] = useState(false);
  const [tableTheadTitle, settableTheadTitle] = React.useState([]);
  const [toggled, setToggled] = React.useState(false);
  const mainToggleButtonRef = React.useRef(null);
  const [showDeleteAllModal, setShowDeleteAllModal] = React.useState({
    show: false,
    deleteType: null, // 'dropped' or 'load'
  });

  const getInventoryTableHeadList = () => {
    setLoading(true);

    getTableList('exportTable')
      .then((res) => {
        if (res.data?.settings?.data) {
          settableTheadTitle(res.data?.settings?.data);
        } else {
          settableTheadTitle([
            { label: 'Size', flex: 1, show: true, object: 'size' },
            {
              label: 'SSL',
              flex: 1.2,
              show: true,
              object: 'ssl',
              hasLink: true,
            },
            {
              label: 'Booking #',
              flex: 1.1,
              show: true,
              object: 'name',
              hasLink: true,
            },
            {
              label: 'Container #',
              flex: 1.2,
              show: true,
              object: 'container',
            },
            {
              label: 'Location',
              flex: 1.2,
              show: true,
              object: 'loc',
            },
            {
              label: 'Gated Out',
              flex: 1.2,
              show: true,
              object: 'gated_out',
            },
            {
              label: 'Gated In',
              flex: 1.2,
              show: true,
              object: 'gated_in',
            },
            { label: 'Vessel', flex: 1.2, show: true, object: 'vessel_name' },
            {
              label: 'Voyage',
              flex: 1,
              show: true,
              object: 'vessel_voyage_in',
            },
            {
              label: 'Terminal Apt.',
              flex: 1.2,
              show: true,
              object: 'appointment_date',
            },
            {
              label: 'Load Pickup',
              flex: 1.2,
              show: true,
              object: 'load_pickup_date',
            },
            {
              label: 'ERD',
              flex: 1.4,
              show: true,
              object: 'erd',
            },
            {
              label: 'Cutoff',
              flex: 1.4,
              show: true,
              object: 'cutoff',
            },
            {
              label: 'Pickup Location',
              flex: 1,
              show: true,
              object: 'pick_up_location',
            },
            {
              label: 'Terminal Return',
              flex: 1.1,
              show: true,
              object: 'return_to_terminal',
              hasLink: true,
            },
            {
              label: 'Vessel Departure',
              flex: 1.2,
              show: true,
              object: 'vessel_departure',
            },
            {
              label: 'Available Date',
              flex: 1.2,
              show: true,
              object: 'date',
            },
            {
              label: 'Last Update',
              flex: 1.5,
              show: true,
              object: 'up',
            },
          ]);
        }
        setLoading(false);
      })
      .catch((err) => {
        // notify(err, 'warning');
        SaveApiResMessage({
          title: 'Error',
          message: err,
          mode: 'warning',
        });
        setLoading(false);
      });
  };

  // Search filtering function
  const filterExportInventoryBySearch = (data, query) => {
    if (!query.trim()) return data;

    return data.filter((item) => {
      // Check if location matches (at inventory level)
      if (item.loc && item.loc.toLowerCase().includes(query.toLowerCase())) {
        return true;
      }

      // Check if any booking matches the search criteria
      if (item.bookings && Array.isArray(item.bookings)) {
        const bookingMatch = item.bookings.some((booking) => {
          // Check if booking number matches
          if (
            booking.name &&
            booking.name.toLowerCase().includes(query.toLowerCase())
          ) {
            return true;
          }
          // Check if container number matches
          if (
            booking.container &&
            booking.container.toLowerCase().includes(query.toLowerCase())
          ) {
            return true;
          }
          return false;
        });
        if (bookingMatch) return true;
      }

      return false;
    });
  };

  // Handle search query changes
  React.useEffect(() => {
    if (DATA.length > 0) {
      const filteredData = filterExportInventoryBySearch(DATA, searchQuery);
      setFilteredData(filteredData);
    }
  }, [searchQuery, DATA]);

  useEffect(() => {
    if (
      filter.appliedFilters &&
      Object.values(filter.appliedFilters).filter(Boolean).length > 0
    ) {
      let arr = DATA;

      // Handle different data structures
      if (filter.appliedFilters.size) {
        arr = arr.filter((i) => {
          const size =
            i.size ||
            i.specification?.size_type ||
            (i.containers && i.containers[0]?.size);
          return size === filter.appliedFilters.size.label;
        });
      }

      if (filter.appliedFilters.ssl) {
        arr = arr.filter((i) => {
          const ssl =
            i.ssl || i.company?.name || (i.containers && i.containers[0]?.ssl);

          return ssl === filter.appliedFilters.ssl.label;
        });
      }

      if (filter.appliedFilters.loc) {
        arr = arr.filter((i) => {
          // For dropped tab: i.loc
          // For load/all tab: i.return_terminals
          const loc =
            i.loc ||
            i.return_terminals ||
            (i.containers && i.containers[0]?.loc);
          return loc && filter.appliedFilters.loc.label.includes(loc);
        });
      }

      // if (form.date) arr = arr.filter((i) => i.size === form.size);
      if (filter.appliedFilters.num)
        arr = arr.filter((i) => i.num <= filter.appliedFilters.num);
      if (filter.appliedFilters.company)
        arr = arr.filter((i) => i.company <= filter.appliedFilters.company);

      // Store applied filters for indicator
      const appliedFilters = {};
      if (filter.appliedFilters.size)
        appliedFilters.size = filter.appliedFilters.size.label;
      if (filter.appliedFilters.ssl)
        appliedFilters.ssl = filter.appliedFilters.ssl.label;
      if (filter.appliedFilters.loc)
        appliedFilters.loc = filter.appliedFilters.loc.label;

      setFilter({ ...filter, DATA: arr, open: false });
    } else {
      // Reset to original data when no filters are applied
      setFilter({ ...filter, DATA: DATA, open: false });
    }
  }, [filter.appliedFilters]);

  const hasAppliedFilters = () => {
    return (
      filter.appliedFilters &&
      Object.entries(filter.appliedFilters).filter(([key, value]) => value)
        .length > 0
    );
  };

  React.useEffect(() => {
    getInventoryTableHeadList();
  }, []);

  React.useEffect(() => {
    if (state.file) {
      setLoading(true);
      importExportInventory(state.file)
        .then((res) => {
          let DATA = ParseExportInventoryList(res);
          setData(DATA);
          const filteredData = filterExportInventoryBySearch(DATA, searchQuery);
          setFilteredData(filteredData);
          setFilter((f) => ({ ...f, DATA, appliedFilters: {} }));
          setLoading(false);
        })
        .catch((err) => {
          // notify(err, 'warning');
          SaveApiResMessage({
            title: 'Error',
            message: err,
            mode: 'warning',
          });
          setData([]);
          setFilteredData([]);
          setFilter((f) => ({ ...f, DATA: [], appliedFilters: {} }));
          setLoading(false);
        });
    }
  }, [state.file, notify]);

  const Del = (id) =>
    delExportInventory(id)
      .then((msg) => {
        // notify(msg);
        SaveApiResMessage({
          title: msg?.data?.messageHeader,
          message: msg,
          mode: 'success',
        });
        getExportInventory()
          .then((res) => {
            let DATA = ParseExportInventoryList(res.data);
            setData(DATA);
            const filteredData = filterExportInventoryBySearch(
              DATA,
              searchQuery
            );
            setFilteredData(filteredData);
            setFilter((f) => ({ ...f, DATA, appliedFilters: {} }));
          })
          .catch((err) => {
            // notify(err, 'warning');
            SaveApiResMessage({
              title: 'Error',
              message: err,
              mode: 'warning',
            });
          });
      })
      .catch((err) => {
        // notify(err, 'warning');
        SaveApiResMessage({
          title: 'Error',
          message: err,
          mode: 'warning',
        });
      });

  const openPopUp = (item, bookingId, booking) => {
    noScroll();
    setState({ ...state, edit: item, bookingId: bookingId, booking: booking });
  };

  const Update = (form, inventory_id, containers) => {
    return upBooking(form, state.bookingId)
      .then((res) => {
        // notify('Updated Successfully.');
        SaveApiResMessage({
          title: res?.data?.messageHeader,
          message: 'Updated Successfully.',
          mode: 'success',
        });
        getExportInventoryList();
        setFilter({ ...filter, DATA });
        closePopup();
      })
      .catch((err) => {
        // notify(err, 'warning');
        SaveApiResMessage({
          title: 'Error',
          message: err,
          mode: 'warning',
        });
      });
  };

  const closePopup = () => {
    removeNoScroll();
    setState({ ...state, edit: null });
  };

  const handleExport = () => {
    // Export functionality can be implemented here
    // notify('Export functionality coming soon', 'info');
    SaveApiResMessage({
      title: 'Info',
      message: 'Export functionality coming soon',
      mode: 'info',
    });
  };

  const getExportInventoryList = () => {
    setLoading(true);
    getExportInventory({ page: pagination.currentPage })
      .then((res) => {
        let DATA = ParseExportInventoryList(res.data);
        let pages = [];
        for (let i = 1; i <= res.last_page; i++) {
          pages.push(i);
        }
        setPagination((prev) => {
          return {
            ...prev,
            pages,
          };
        });
        setData(DATA);
        const filteredData = filterExportInventoryBySearch(DATA, searchQuery);
        setFilteredData(filteredData);
        setFilter({ open: false, DATA, appliedFilters: {} });
        setLoading(false);
      })
      .catch((err) => {
        // notify(err, 'warning');
        SaveApiResMessage({
          title: 'Error',
          message: err,
          mode: 'warning',
        });
        setLoading(false);
      });
  };

  const getExportInventoryListNotLoading = () => {
    getExportInventory({ page: pagination.currentPage })
      .then((res) => {
        let DATA = ParseExportInventoryList(res.data);
        let pages = [];
        for (let i = 1; i <= res.last_page; i++) {
          pages.push(i);
        }
        setPagination((prev) => {
          return {
            ...prev,
            pages,
          };
        });
        setData(DATA);
        const filteredData = filterExportInventoryBySearch(DATA, searchQuery);
        setFilteredData(filteredData);
        setFilter({ open: false, DATA, appliedFilters: {} });
        setLoading(false);
      })
      .catch((err) => {
        // notify(err, 'warning');
        SaveApiResMessage({
          title: 'Error',
          message: err,
          mode: 'warning',
        });
        setLoading(false);
      });
  };

  React.useEffect(() => {
    getExportInventoryList();
  }, [pagination.currentPage]);

  // Handle delete all button click - show confirmation modal
  const handleDeleteAllClick = () => {
    setShowDeleteAllModal({ show: true });
  };

  // Handle delete all confirmation
  const handleDeleteAllConfirm = () => {
    deleteAllBookingsApi()
      .then((msg) => {
        // notify(msg);
        SaveApiResMessage({
          title: msg?.data?.messageHeader,
          message: msg,
          mode: 'success',
        });
        getExportInventory()
          .then((res) => {
            let DATA = ParseExportInventoryList(res.data);
            setData(DATA);
            const filteredData = filterExportInventoryBySearch(
              DATA,
              searchQuery
            );
            setFilteredData(filteredData);
            setFilter({ ...filter, DATA, appliedFilters: {} });
            setLoading(false);
          })
          .catch((err) => {
            // notify(err, 'warning');
            SaveApiResMessage({
              title: 'Error',
              message: err,
              mode: 'warning',
            });
          });
      })
      .catch((err) => {
        // notify(err, 'warning');
        SaveApiResMessage({
          title: 'Error',
          message: err,
          mode: 'warning',
        });
      });

    setShowDeleteAllModal({ show: false, deleteType: null });
  };

  return (
    <PageContainer
      title="Your Export"
      icon="yourExport"
      mainPage={true}
      minWidth="auto"
      rightContent={
        <AddButton
          title="Add Export"
          onClick={() => {
            setOpenAdd(true);
          }}
        />
      }>
      {state.edit && (
        <Edit
          data={state.edit}
          bookingId={state.bookingId}
          Close={closePopup}
          Update={Update}
          booking={state.booking}
        />
      )}

      <div className={cls.tabsContainer}>
        <div></div>
        <div className="flex flex-wrap flex-col sm:flex-row gap-3 py-2 justify-between w-full lg:w-auto lg:justify-start">
          <SearchContainer
            width={'264px'}
            placeholder="Search Booking, Location or Container"
            setContainerName={setSearchQuery}
            setPage={() => {}}
          />

          <IconButton
            text="Delete All"
            icon="deleteIcon"
            color="#FF0000"
            onClick={() => {
              handleDeleteAllClick();
            }}
          />
          <IconButton
            ref={mainToggleButtonRef}
            active={options.open}
            text="Column"
            icon="options"
            color="#131517"
            onClick={() => {
              setOptions(
                options.open ? { open: false } : { ...options, open: true }
              );
              setToggled(true);
              setFilter({ ...filter, open: false });
            }}
          />
          <IconButton
            active={filter.open || hasAppliedFilters()}
            text="Filter"
            icon="filter"
            color="#131517"
            onClick={() => {
              setFilter({ ...filter, open: filter.open ? false : true });
              setOptions({ ...options, open: false });
            }}
          />
          <IconButton
            text="Export XLSX"
            icon="exportXLSXIcon"
            color="#131517"
            onClick={handleExport}
          />
        </div>
      </div>

      <CustomFilter
        filtersList={['size', 'ssl', 'loc']}
        noTitleAndIcon={true}
        filter={filter}
        setFilter={setFilter}
        DATA={DATA || []}
      />

      {hasAppliedFilters() && (
        <div className="relative z-99 w-full bg-white rounded-lg items-center flex flex-wrap gap-2  p-3 ">
          <span className="text-sm">Filtered by:</span>
          {Object.entries(filter.appliedFilters)
            .filter(([key, value]) => value)
            .map(([key, value]) => {
              return (
                <CustomBadge
                  key={key}
                  text={value?.label}
                  onClick={() => {
                    const newFilters = { ...filter.appliedFilters };
                    delete newFilters[key];

                    setFilter({
                      ...filter,
                      appliedFilters: newFilters,
                    });
                  }}
                />
              );
            })}
        </div>
      )}

      <Options
        noTitleAndIcon={true}
        options={options}
        tableType={'exportTable'}
        tableTheadTitle={tableTheadTitle || []}
        toggled={toggled}
        setOptions={setOptions}
        mainToggleButtonRef={mainToggleButtonRef}></Options>

      <Modal
        noX
        minWidth="unset"
        notClose={true}
        show={openAdd}
        setShow={setOpenAdd}
        icon={'addExportIcon'}
        title="Add Export"
        rightContent={
          <div className={cls.cardHeader}>
            <div className={cls.row}>
              <span className={cls.title}>Import</span>
              <label className={cls.import}>
                <input
                  type="file"
                  style={{ display: 'none' }}
                  accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                  onChange={(e) => {
                    setState({ ...state, file: e.target.files[0] });
                    e.target.value = null;
                    setOpenAdd(false);
                  }}
                />
                <span>XLSX</span>
              </label>
            </div>
          </div>
        }>
        <div className={cls.addContainerSection}>
          <Add
            notify={notify}
            setOpenAdd={setOpenAdd}
            setData={(res) => {
              let DATA = ParseExportInventoryList(res);
              setData(DATA);
              const filteredData = filterExportInventoryBySearch(
                DATA,
                searchQuery
              );
              setFilteredData(filteredData);
              setFilter({ ...filter, DATA, appliedFilters: {} });
            }}
            getExportInventoryList={getExportInventoryList}
          />
        </div>
      </Modal>

      {loading ? (
        <div className="mt-16">
          <LoadingV2 />
        </div>
      ) : (
        <List
          DATA={
            searchQuery
              ? filteredData
              : filter.DATA !== undefined
              ? filter.DATA
              : DATA
          }
          Del={Del}
          Edit={openPopUp}
          getExportInventoryList={getExportInventoryList}
          getExportInventoryListNotLoading={getExportInventoryListNotLoading}
          currentPage={pagination.currentPage}
          tableTheadTitle={tableTheadTitle}
        />
      )}
      <Pagination pagination={pagination} setPagination={setPagination} />
      <Modal
        minWidth="unset"
        noX
        show={showDeleteAllModal.show}
        children={
          <span className="mt-6 text-center w-full md:min-w-xl">
            Are you sure you want to delete all exported containers?
          </span>
        }
        submitText={'Yes, Delete All'}
        icon={'deleteIcon'}
        title={`Delete All Exported Containers`}
        setShow={(value) => {
          setShowDeleteAllModal({
            show: value,
          });
        }}
        submit={handleDeleteAllConfirm}
        loadingbutton={false}
      />
    </PageContainer>
  );
};
